var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPlay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 12,
    viewBox: "0 0 9 12",
    fill: "currentcolor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.98188 5.43784L1.74187 0.901838C1.51287 0.735838 1.20888 0.710838 0.957875 0.839838C0.704875 0.967838 0.546875 1.22784 0.546875 1.50884V10.5778C0.546875 10.8618 0.704875 11.1208 0.957875 11.2488C1.06488 11.3028 1.18188 11.3298 1.29988 11.3298C1.45388 11.3298 1.60987 11.2808 1.74187 11.1838L7.98188 6.65184C8.17888 6.50684 8.29388 6.28284 8.29388 6.04484C8.29488 5.80284 8.17688 5.57984 7.98188 5.43784Z",
    fill: "currentcolor"
  })));
}

export default SvgPlay;